export default __webpack_public_path__ + "static/media/Union.74d22add.svg";